import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {ActionHandler} from "../../../../infrastructure/handlers/action-handler";
import {NewSearchWidgetQueryNextActionEvent} from "../../models/analytics/new-search-widget.query-next-action.event";

export class NewSearchWidgetQueryNextActionEventHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onNextActionQueryEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  async action(params) {
    const event: NewSearchWidgetQueryNextActionEvent = new NewSearchWidgetQueryNextActionEvent(params);

    this.analyticsService.createEvent(event);
  }
}
